export function getMappedIntent(intent: string): string | undefined {
    if (intent === "out_of_scope") return undefined;
    return intent;
}
